


































import { Mixins, Component, Model, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "@/domain";
import { FileSizeConverter } from "@/utilities";
import { Folder } from "@/domain/folder";
import Enumerable from "linq";

@Component
export default class FileUploadDialog extends Mixins() {
  @Model("input")
  isVisible: boolean;

  @Prop()
  folderGuid: string;

  data() {
    return {
      visible: false,
      isUploading: false,
      tableData: [] as File[],
      selectedFiles: [] as File[],
      errorDate: [] as File[],
    };
  }
  visible: boolean;
  isUploading: boolean;
  tableData: File[];
  selectedFiles: File[];
  errorDate: File[];

  $refs!: {
    input: HTMLInputElement,
  };

  addFiles(files: FileList): void {
    for (const file of files) {
      this.tableData.push(file);
    }
    this.$refs.input.value = "";
  }

  toFileSize(size: number): string {
    return FileSizeConverter.toString(size);
  }

  openDialog(): void {
    this.$refs.input.click();
  }

  selectionChanged(value: File[]): void {
    this.selectedFiles = value;
  }

  deleteSelectedFiles(): void {
    this.tableData = this.tableData.filter(v => !this.selectedFiles.some(sv => v === sv));
    this.selectedFiles = [];
  }

  onCancel(): void {
    this.visible = false;
  }

  async onConfirm(): Promise<void> {
    this.isUploading = true;

    // フォルダの合計サイズが変わっているかもしれないのでアップロード時に情報取得
    const latestFolder = await this.getLatestFolderInfo(this.folderGuid);
    if (!latestFolder) {
      this.isUploading = false;
      return;
    }
    // アップロードファイルサイズのチェック
    if (this.isOverUploadFileSize(latestFolder)) {
      this.isUploading = false;
      this.$error("アップロード不可", "フォルダのサイズが規定値を超えるため、ファイルのアップロードできません。");
      return;
    }
    
    this.uploadFile();
  }

  private isOverUploadFileSize(folder: Folder): boolean {
    const uploadFileSize = Enumerable.from(this.tableData)
      .select(f => f.size).sum();
    return (folder.maxSize < (folder.size + uploadFileSize));
  }

  private uploadFile(): void {
    const file = this.tableData.shift();
    this.upload(file.name, file);
  }

  private async upload(fileName: string, file: File): Promise<void> {
    const repository = DomainRegistry.file.getFileRepository();
    try {
    await repository.uploadFile(this.folderGuid, fileName, file);
    } catch {
      this.errorDate.push(file);
    }
    if (this.tableData.length > 0) {
      this.uploadFile();
      return;
    } 
    if (this.errorDate.length > 0) {
      this.$error("ファイルアップロードエラー", "ファイルアップロード中にエラーが発生しました。");
      // TODO: エラー発生したファイルを表示する？
    }
    this.uploaded();
  }

  private uploaded(): void {
    this.isUploading = false;
    this.confirm();
    this.visible = false;
  }

  async getLatestFolderInfo(folderGuid: string): Promise<Folder> {
    try {
      const repository = DomainRegistry.folder.getFolderRepository();
      return await repository.getFolder(folderGuid);
    } catch (e) {
      this.$error("フォルダ情報取得エラー", "フォルダ情報の取得中にエラーが発生しました。", e);
      return null;
    }
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    this.isUploading = false;
    this.tableData = [];
    this.selectedFiles = [];
    this.errorDate = [];
    this.visible = newValue;
  }

  @Watch("visible")
  onVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    this.input(newValue);
  }

  @Emit()
  confirm(): void {}

  @Emit()
  input(value: boolean): void {}
}
